import { Component, OnInit } from '@angular/core';
import { LoadingAndErrors } from '../../../../classes';
import { Pagination } from '../../../../interfaces';
import { ProductsService } from '../../../../services';
import { LoopBackConfig, LoopBackAuth, PartnerApi, OtherOrderApi } from '../../../../../assets/js/lb-sdk';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { ORDER_STATUS, USER_ROLES, PAYMENT_METHOD } from '../../../../enums';

@Component({
  selector: 'app-other-order-details',
  templateUrl: './other-order-details.component.html',
  styleUrls: ['./other-order-details.component.css']
})
export class OtherOrderDetailsComponent extends LoadingAndErrors implements OnInit {
  host: string = LoopBackConfig.getPath();
  ORDER_STATUS: typeof ORDER_STATUS = ORDER_STATUS;
  PAYMENT_METHOD: typeof PAYMENT_METHOD = PAYMENT_METHOD;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  pagination: Pagination = {
    page: 1,
    limit: 10,
    total: 0
  };
  state;
  merchantDetails;
  order: any = {};

  constructor(
    private route: ActivatedRoute,
    public partnerApi: PartnerApi,
    public productService: ProductsService,
    private orderApi: OtherOrderApi,
    private loopBackAuth: LoopBackAuth
  ) {
    super();
  }

  ngOnInit() {
    this.route.paramMap
      .subscribe(params => {
        this.state = {...params};
        this.loadOrderDetails();
      });
  }

  loadOrderDetails() {
    this.loading.order = true;
    this.clearErrors();
    this.orderApi
      .findById(this.state.params.id, {
        include: [
          'payments', {
            relation: 'orderItems',
            scope: {
              include: [{
                relation: 'commissions',
                scope: {
                  where: {
                    orderId: this.state.params.id
                  }
                }
              }]
            }
          }
        ]
      })
      .pipe(finalize(() => {
        this.loading.order = false;
      }))
      .subscribe(order => {
        this.order = order;
      }, error => {
        this.errors.order = error.message || 'Failed to load order details';
      });
  }

  commissionsLength() {
    return this.order && this.order.orderItems && this.order.orderItems
      .reduce((total, orderItem) => {
        return total + (orderItem.commissions || []).length;
      }, 0) || 0;
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
